import script from "./CompetenceSet.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetenceSet.vue?vue&type=script&setup=true&lang=js"

import "./CompetenceSet.vue?vue&type=style&index=0&id=75bfe545&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75bfe545"]])

export default __exports__